import { render, staticRenderFns } from "./ElementSmzCommentsTableColumn.vue?vue&type=template&id=0a651503&scoped=true"
import script from "./ElementSmzCommentsTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementSmzCommentsTableColumn.vue?vue&type=script&lang=js"
import style0 from "./ElementSmzCommentsTableColumn.vue?vue&type=style&index=0&id=0a651503&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a651503",
  null
  
)

export default component.exports